class HHAnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.announcement-bar__item'))
    this.interval = Number(this.dataset.interval) || 0

    if (this.items.length < 2 || this.interval <= 0) return

    this.index = this.items.findIndex((item) => item.classList.contains('is-active'))
    if (this.index < 0) this.index = 0

    this.timer = null
    this.pause = this.pause.bind(this)
    this.resume = this.resume.bind(this)
    this.onVisibilityChange = this.onVisibilityChange.bind(this)

    this.addEventListener('mouseenter', this.pause)
    this.addEventListener('mouseleave', this.resume)
    this.addEventListener('focusin', this.pause)
    this.addEventListener('focusout', this.resume)
    document.addEventListener('visibilitychange', this.onVisibilityChange)

    this.nextButton = this.querySelector('[data-announcement-next]')
    this.onNextClick = this.onNextClick.bind(this)
    this.nextButton?.addEventListener('click', this.onNextClick)

    this.onKeydown = this.onKeydown.bind(this)
    this.addEventListener('keydown', this.onKeydown)

    this.resume()
  }

  disconnectedCallback() {
    this.pause()
    document.removeEventListener('visibilitychange', this.onVisibilityChange)
  }

  pause() {
    clearInterval(this.timer)
    this.timer = null
  }

  resume() {
    if (this.timer || document.hidden) return
    if (this.matches(':hover') || this.contains(document.activeElement)) return

    this.timer = setInterval(() => this.show((this.index + 1) % this.items.length), this.interval)
  }

  onVisibilityChange() {
    if (document.hidden) this.pause()
    else this.resume()
  }

  onNextClick() {
    this.show((this.index + 1) % this.items.length)
  }

  onKeydown(event) {
    const total = this.items.length
    let next = null

    if (event.key === 'ArrowRight') next = (this.index + 1) % total
    if (event.key === 'ArrowLeft') next = (this.index - 1 + total) % total
    if (next === null) return

    event.preventDefault()
    this.show(next)
  }

  show(next) {
    if (next === this.index) return

    const current = this.items[this.index]
    const upcoming = this.items[next]
    const heldFocus = current === document.activeElement || current.contains(document.activeElement)

    current.classList.remove('is-active')
    current.setAttribute('inert', '')

    upcoming.classList.add('is-active')
    upcoming.removeAttribute('inert')

    this.index = next

    if (heldFocus) {
      const link = upcoming.matches('a[href]') ? upcoming : upcoming.querySelector('a[href]')
      const target = link || this.nextButton
      target?.focus()
    }
  }
}

customElements.define('hh-announcement-bar', HHAnnouncementBar)
